module.exports = __webpack_public_path__ + "img/teal-t-shirt.e51a07b8.jpg";